export async function ensureFullCompany<T extends { id?: number }>(
    company: T | undefined,
    loadFullCompany: (id: number) => Promise<T | undefined>,
    companyId?: number
): Promise<T | undefined> {
    const id = company?.id ?? companyId;
    if (!id) {
        return undefined;
    }

    const fullCompany = await loadFullCompany(id);
    return fullCompany;
}

export function isCompanyDetailsFormReady({
    isCreateCompanyForm,
    activeCompanyId,
    hydratedCompanyId
}: {
    isCreateCompanyForm: boolean;
    activeCompanyId?: number;
    hydratedCompanyId: number | null;
}): boolean {
    if (isCreateCompanyForm) {
        return true;
    }

    return Boolean(activeCompanyId) && hydratedCompanyId === activeCompanyId;
}
